import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Utils from "../../lib/utils";
import { WhiteButtonLink, Title, Bold } from "../Styles";
import { DocumentViewer } from "../Shared";
import { getResumes } from "../../redux/middleware/resume";
import { getProfiles } from "../../redux/middleware/profile";
import {
  getProfilesError,
  getProfilesPending,
  getProfiles as getProfilesState,
} from "../../redux/reducers/profile";
import {
  getResumePending,
  getResumes as getResumesState,
} from "../../redux/reducers/resume";

const Container = styled.div`
  color: #8290a2;
  label {
    font-weight: 500;
  }
  input[type=checkbox], input[type=radio] {
    margin: 4px 10px 0 0;
    margin-top: 1px\9;
    line-height: normal;
  }
  @media screen and (max-width: 414px) {
    span.divider {
      display: none;
    }
  }
`

const MainContent = styled.div`
  padding: 0 0 0 20px;

  @media screen and (max-width: 736px) {
    padding: 0;
  }
`

const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const HeaderTitle = styled.div`
  width: 100%;
  float: left;
  margin: 0 0 7px;
  font-family: 'Raleway';
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`

const HeaderDetails = styled.div`
  padding-bottom: 10px;
  font-size: 14px;
  font-family: 'Raleway';
  color: #8290a2;
  font-weight: 500;
  display: inline-block;
`

const UserName = styled.div`
  width: 100%;
  float: left;
  margin: 42px 0 20px;
  font-weight: 700;
  color: #39b54a;
  font-family: 'Raleway';
  font-size: 24px;
  padding-bottom: 15px;
`

const MainSection = styled.div`
  border-bottom: 1px solid #8da3aa;
  height: 85px;
  clear: both;
`

const EditLink = styled.div`
  margin-top: 52px;
  float: right;
  font-size: 16px;
  font-weight: 600;
  a {
    color: #0a3949;
  }
  @media screen and (max-width: 1200px) {
    margin-top: 50px;
  }
  @media screen and (max-width: 991px) {
    margin-top: -60px;
  }
`

const DownloadLink = styled.div`
  color: #337ab7;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
`

const ProfileDetails = styled.div`
  padding: 40px 0;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    float: left;
    margin-right: 20px;
  }
  i {
    margin-right: 8px;
  }
`

const Sections = styled.div`
  margin-bottom: 40px;
`

const ProfileHeader = ({profile, lastUpdated}) =>
  <Header>
    <HeaderTitle>Profile</HeaderTitle>
    <HeaderDetails style={{marginRight: 5}}>
      { profile.primary ? "Primary" : "Not Primary" }
    </HeaderDetails>
    /
    <HeaderDetails style={{marginLeft: 5, marginRight: 5}}>
      { profile.searchable ? "Searchable" : "Not Searchable" }
    </HeaderDetails>
    <span className="divider">/&nbsp;</span>
    <HeaderDetails>
      Last Updated: {lastUpdated}
    </HeaderDetails>
  </Header>

const ProfileMainContent = ({
  profile,
  user,
  profileLink,
  employmentTypes,
  show,
  showDocumentViewer,
  hideDocumentViewer,
  resume,
}) => (
  <MainContent>
    <MainSection>
      <Row>
        <Col md={6}>
          <UserName>
            {user.fname} {user.lname}
          </UserName>
        </Col>
        <Col md={6}>
          {Utils.isApplicant(user) && (
            <EditLink>
              <Link to={profileLink}>Edit Profile</Link>
            </EditLink>
          )}
        </Col>
      </Row>
    </MainSection>
    <ProfileDetails>
      <Row>
        <Col md={12} xsHidden>
          <ul>
            {user && user.phone_primary && (
              <li>
                <label>
                  <i className="fa fa-phone" />
                  {user.phone_primary}
                </label>
              </li>
            )}
            {user && user.email && (
              <li>
                <label>
                  <i className="fa fa-envelope-o" /> {user.email}
                </label>
              </li>
            )}
            {((user && user.city) || (user && user.state)) && (
              <li>
                <label>
                  <i className="fa fa-location-arrow" /> {user.city},{" "}
                  {user.state} {user.zip}
                </label>
              </li>
            )}
          </ul>
        </Col>
      </Row>
      <Row>
        <Col xs={1} smHidden mdHidden lgHidden>
          <Bold>
            <i className="fa fa-phone"></i>
          </Bold>
        </Col>
        <Col xs={11} smHidden mdHidden lgHidden>
          <Bold>{user.phone_primary}</Bold>
        </Col>
      </Row>
      <Row>
        <Col xs={1} smHidden mdHidden lgHidden>
          <Bold>
            <i className="fa fa-envelope-o"></i>
          </Bold>
        </Col>
        <Col xs={11} smHidden mdHidden lgHidden>
          <Bold>{user.email}</Bold>
        </Col>
      </Row>
      <Row>
        <Col xs={1} smHidden mdHidden lgHidden>
          <Bold>
            <i className="fa fa-location-arrow"></i>
          </Bold>
        </Col>
        <Col xs={11} smHidden mdHidden lgHidden>
          <Bold>
            {user.city}, {user.state} {user.zip}
          </Bold>
        </Col>
      </Row>
    </ProfileDetails>
    <Sections>
      <Title>{profile.title}</Title>
      <Row className="profile_detail post">
        <Col lg={2}>
          <label>{employmentTypes && employmentTypes.join(", ")}</label>
        </Col>
      </Row>
      <Row>
        <Col md={3} xs={6}>
          <Bold>{"US Citizen?"}</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && profile.us_citizen ? "Yes" : "No"}
        </Col>
        <Col md={3} xs={6}>
          <Bold>{"Relocate?"}</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && profile.relocate ? "Yes" : "No"}
        </Col>
      </Row>
      <Row>
        <Col md={3} xs={6}>
          <Bold>{"Security Clearance?"}</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && profile.security_clearance ? "Yes" : "No"}
        </Col>
        <Col md={3} xs={6}>
          <Bold>{"Military Veteran?"}</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && profile.veteran ? "Yes" : "No"}
        </Col>
      </Row>
      <Row>
        <Col md={3} xs={6}>
          <Bold>Annual Salary:</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && Utils.currencyFormatter(profile.salary)}
        </Col>
        <Col md={3} xs={6}>
          <Bold>Hourly Rate:</Bold>
        </Col>
        <Col md={3} xs={6}>
          {profile && Utils.currencyFormatter(profile.hourly_rate, 2)}
        </Col>
      </Row>
      <Row>
        <Col md={3} xs={6}>
          <Bold>Resume:</Bold>
        </Col>
        <Col md={3} xs={6}>
          {resume ? (
            <div onClick={showDocumentViewer}>
              <DownloadLink>View</DownloadLink>
            </div>
          ) : (
            <div className="input">
              {Utils.isApplicant(user) && (
                <Link to={profileLink}>
                  <i className="fa fa-plus-circle"></i> Add a resume
                </Link>
              )}
            </div>
          )}
        </Col>
      </Row>
    </Sections>
    <Sections>
      <Title>Skills</Title>
      <Row>
        <Col lg={12}>
          {profile.skill_sets &&
            profile.skill_sets.map((skillSet, i) => (
              <Row key={i}>
                <Col xs={3}>{skillSet.skill}</Col>
                <Col xs={3}>{skillSet.years_experience} Years</Col>
                <Col xs={6}>Last used in {skillSet.last_used}</Col>
              </Row>
            ))}
        </Col>
      </Row>
      {Utils.isApplicant(user) && (
        <WhiteButtonLink style={{ marginTop: 20 }} to={`${profileLink}#skills`}>
          Add skill
        </WhiteButtonLink>
      )}
    </Sections>
    <Sections>
      <Title>Work Experience</Title>
      <Row>
        <Col lg={12}>
          {profile.work_experiences &&
            profile.work_experiences.map((exp, i) => (
              <Row
                key={i}
                style={{
                  marginBottom:
                    i < profile.work_experiences.length - 1 ? 10 : undefined,
                }}
              >
                <Col lg={3}>{exp.title}</Col>
                <Col lg={3}>{exp.company}</Col>
                <Col lg={3}>{moment(exp.start_date).format("MM/DD/YYYY")}</Col>
                <Col lg={3}>
                  {exp.end_date && moment(exp.end_date).format("MM/DD/YYYY")}
                </Col>
              </Row>
            ))}
        </Col>
      </Row>
      {Utils.isApplicant(user) && (
        <WhiteButtonLink
          style={{ marginTop: 20 }}
          to={`${profileLink}#experiences`}
        >
          Add work experience
        </WhiteButtonLink>
      )}
    </Sections>
    <Sections>
      <Title>Education</Title>
      <Row>
        <Col lg={12}>
          {profile.educations &&
            profile.educations.map((education, i) => (
              <Row key={i}>
                <Col xs={6} md={3}>
                  {Utils.uppercase(education.education_type || "")}
                </Col>
                <Col xs={6} md={3}>
                  {education.institution}
                </Col>
                <Col md={3} className="hidden-xs">
                  {education.city_state}
                </Col>
                <Col md={3} className="hidden-xs">
                  {education.country}
                </Col>
              </Row>
            ))}
        </Col>
      </Row>
      {Utils.isApplicant(user) && (
        <WhiteButtonLink
          style={{ marginTop: 20 }}
          to={`${profileLink}#education`}
        >
          Add education
        </WhiteButtonLink>
      )}
    </Sections>
    <DocumentViewer
      show={show}
      hide={hideDocumentViewer}
      content={resume && resume.content}
      title={`${user.fname} ${user.lname}'s Resume`}
    />
  </MainContent>
);

class Profile extends Component {
  shouldComponentRender = () => {
    const { pending, profile } = this.props;
    if (this.pending === false) return false;
    if (profile === undefined) return false;
    return true;
  };

  componentWillMount() {
    const {
      getProfile,
      getProfiles,
      profile_id,
      resumes,
      user,
      history: { location },
    } = this.props;
    getProfile(profile_id);
    this.setState({ show: false });
    if (location.profile) {
      getProfiles(user.id);
      this.setState({
        resume: resumes[resumes.length - 1],
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      getProfiles,
      resumePending,
      user,
      history: { location },
    } = this.props;
    if (resumePending && !nextProps.resumePending) {
      user && getProfiles(user.id);
    }
    !location.profile && this.getResume();
  }

  hideDocumentViewer = () => {
    this.setState({ show: false });
  };

  showDocumentViewer = () => {
    this.setState({ show: true });
  };

  getResume = () => {
    const { profiles, profile_id, resumes } = this.props;
    const profile =
      profiles && profiles.find((profile) => profile.id === Number(profile_id));

    const resumeId = profile && profile.resume_id;
    resumes &&
      this.setState({
        resume: resumes.find((resume) => resume.id === resumeId),
      });
  };

  render() {
    if (!this.shouldComponentRender()) return <div>Loading...</div>;

    const { employmentTypes, user, history } = this.props;
    let profile;
    if (history.location.profile) profile = history.location.profile;
    else profile = this.props.profile;
    const profileLink = `/dashboard/profiles/${profile.id}/edit`;
    const lastUpdated = moment(profile.updated_at).format("MM/DD/YYYY");

    return (
      <Container className="TabbedPanelsContent TabbedPanelsContentVisible">
        <ProfileHeader profile={profile} lastUpdated={lastUpdated} />
        <ProfileMainContent
          user={user}
          profile={profile}
          resume={this.state.resume}
          profileLink={profileLink}
          employmentTypes={employmentTypes}
          show={this.state.show}
          showDocumentViewer={this.showDocumentViewer}
          hideDocumentViewer={this.hideDocumentViewer}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  pending: getProfilesPending(state),
  resumePending: getResumePending(state),
  resumes: getResumesState(state),
  profiles: getProfilesState(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    getResumes: (user) => dispatch(getResumes(user)),
    getProfiles: (user) => dispatch(getProfiles(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
